"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  notifications: 'Newsfeed',
  notificationsHint: 'Here are the events you should look out for',
  markAllAsRead: 'Read all the news'
};